export { Socket } from './Socket.js'
export { Touch } from './Touch.js'

export const exponentialBackoff = (toTry, max, delay, onSuccess, onError, indefinite = false) => {
  const result = toTry()
  if (result) {
    onSuccess()
  } else {
    if (max > 0) {
      setTimeout(() => {
        // Randomly adds extra time between 0-3 seconds to prevent clients reconnecting at the same time
        const randomExtraTime = Math.floor(Math.random() * 3) * 1000
        exponentialBackoff(
          toTry,
          --max,
          delay * 2 + randomExtraTime,
          onSuccess,
          onError,
          indefinite
        )
      }, delay)
    } else {
      if (indefinite) {
        if (max === 0) {
          onError()
        }
        setTimeout(() => {
          exponentialBackoff(toTry, --max, delay, onSuccess, onError, indefinite)
        }, delay)
      } else {
        onError()
      }
    }
  }
}
